import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Button, ConfirmationPopup as BaseConfirmationPopup } from '@atlas/ui';

import { isFunction } from 'common/utils';

const ConfirmationPopup = props => {
  const {
    data = {},
    id,
    message,
    // status,
    title,
  } = props;
  const { className, closeLabel = 'no', confirmLabel = 'confirm', secondaryBtn = true } = data;

  const onCloseHandler = useCallback(() => {
    if (isFunction(data.onClose)) {
      data.onClose();
    }

    NotificationManager.removeNotification(id);
  }, []);

  const onConfirmHandler = useCallback(() => {
    if (isFunction(data.onConfirm)) {
      data.onConfirm();
    }

    NotificationManager.removeNotification(id);
  }, []);

  return (
    <BaseConfirmationPopup className={cx('confirm-popup', className)} text={message} title={title}>
      <div className="popup__buttons">
        <Button className="primary block" label={confirmLabel} onClick={onConfirmHandler} />
        {secondaryBtn && (
          <Button className="secondary block" label={closeLabel} onClick={onCloseHandler} />
        )}
      </div>
    </BaseConfirmationPopup>
  );
};

ConfirmationPopup.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  message: PropTypes.string,
  title: PropTypes.string,
};

export default ConfirmationPopup;
